// extracted by mini-css-extract-plugin
export default {"header":"styles_header__rErM7","logo":"styles_logo__CsOgg"};